import styled from 'styled-components'
import { colors } from '../../../styles/vars/colors.style'
import { mq } from '../../../styles/vars/media-queries.style'

export const MapWrapper = styled.div`
  background: ${colors.dark};
  display: none;
  margin-top: -0.2rem;
  overflow: hidden;
  position: relative;

  ${mq.desk} {
    display: block;
  }
`
